import vars from '../helpers';

const init = () => {
	const article = vars.$document.find('.article');
	const articleContent = article.find('.article__content');
	const articleTitle = article.find('.article__heading');
	const articleRefs = article.find('.article__map-refs');
	const articleText = article.find('.article__text, .article__details');
	const articleImage = article.find('.article__image');
	const articleMiniMap = article.find('.article__mini-map');
	const articleClose = article.find('.article__closer');
	const articleArk = article.find('.arc');

	if (!vars.isMobile()) {
		gsap.timeline().from(articleContent, 1.5, {
			autoAlpha: 0,
			yPercent: 100,
			onStart: () => {
				articleContent.removeClass('is-hidden-desktop');
			},
		})
			.from(articleTitle, 0.5, {
				autoAlpha: 0,
				yPercent: 10,
				onStart: () => {
					articleTitle.removeClass('is-hidden-desktop');
				},
			})
			.from(articleRefs, 0.5, {
				autoAlpha: 0,
				yPercent: 10,
				onStart: () => {
					articleRefs.removeClass('is-hidden-desktop');
				},
			})
			.from(articleText, 0.5, {
				autoAlpha: 0,
				yPercent: 10,
				onStart: () => {
					articleText.removeClass('is-hidden-desktop');
				},
			})
			.from(articleImage, 0.5, {
				autoAlpha: 0,
				xPercent: -50,
				onStart: () => {
					articleImage.removeClass('is-hidden-desktop');
				},
			})
			.from(articleMiniMap, 0.5, {
				scale: 0,
				clearProps: 'all',
				onStart: () => {
					articleMiniMap.removeClass('is-hidden-desktop');
				},
			})
			.from(articleClose, 0.5, {
				autoAlpha: 0,
				onStart: () => {
					articleClose.removeClass('is-hidden-desktop');
					articleContent.addClass('is-animate');
				},
			});
	} else {
		articleContent.removeClass('is-hidden-desktop');
		articleTitle.removeClass('is-hidden-desktop');
		articleRefs.removeClass('is-hidden-desktop');
		articleText.removeClass('is-hidden-desktop');
		articleImage.removeClass('is-hidden-desktop');
		articleMiniMap.removeClass('is-hidden-desktop');
		articleClose.removeClass('is-hidden-desktop');

		vars.$document.on('scroll', (event) => {
			const scroll = window.scrollY;
			const content = vars.$document.find('.article__content');

			if (scroll > content.offset().top) {
				// articleArk.removeClass('is-hidden').addClass('is-view');
				articleImage.addClass('is-hidden');
				content.addClass('is-view');
			} else {
				// articleArk.removeClass('is-view');
				content.removeClass('is-view');
				articleImage.removeClass('is-hidden');
			}
		});
	}
};

export default {
	init,
};
